import { render } from "./Challenge.vue?vue&type=template&id=b85aea3a&scoped=true"
import script from "./Challenge.vue?vue&type=script&lang=js"
export * from "./Challenge.vue?vue&type=script&lang=js"

import "./Challenge.vue?vue&type=style&index=0&id=b85aea3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85aea3a"],['__file',"src/components/Challenge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b85aea3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b85aea3a', __exports__)) {
    api.reload('b85aea3a', __exports__)
  }
  
  module.hot.accept("./Challenge.vue?vue&type=template&id=b85aea3a&scoped=true", () => {
    api.rerender('b85aea3a', render)
  })

}


export default __exports__